import i18next, {ParseKeys, TFunction} from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import merge from 'lodash/merge';

import {createRootContextHook} from 'common/util/react';

import locales from './locales.json';
import en from './locales/en.json';

type Locale = {
  code: string;
  displayName: string;
  englishName: string;
};

/** A list of supported languages. */
export const LOCALES: Locale[] = locales;

const defaultNS = `translation`;

i18next
  .use(
    resourcesToBackend(async (language) => {
      const [generated, overrides] = await Promise.all([
        // eslint-disable-next-line no-unsanitized/method
        import(`./locales/generated/${language}.json`).then((module) => module.default),
        // eslint-disable-next-line no-unsanitized/method
        import(`./locales/${language}.json`).then((module) => module.default).catch(() => ({})),
      ]);

      // eslint-disable-next-line prototype-pollution-security-rules/detect-merge-objects
      return merge({}, generated, overrides);
    }),
  )
  .init({
    lng: `en`,
    fallbackLng: `en`,
    defaultNS,
  });

// we always want English to be available immediately
i18next.addResourceBundle(`en`, defaultNS, en);

/**
 * A hook that re-renders the component when the current language changes.
 */
export const useTranslation = createRootContextHook(`i18n`);

export function changeLanguage(code: string) {
  // todo: save preferences to local storage
  i18next.changeLanguage(code);
}

// eslint-disable-next-line @typescript-eslint/ban-types
export type TranslationKey = ParseKeys<typeof defaultNS, {}, ''>;
export type Translatable = string | ((t: TFunction) => string);

export {i18next};
export type {TFunction};
